<template>
  <controller>
    <span ref="form"></span>
    <page-header title="Permissões" >
      <template v-slot:side>
          <a href="#" @click.prevent="novo" class="btn btn-primary">
            Criar Permissão
          </a>
        </template>
    </page-header>

    <section class="permissoes">
      <transition name="fade">
        <criarPermissoes
          v-if="criar"
          :criarID="criarID"
          @close="close"
          @updateParentList="updateParentList"
        />
      </transition>

      <div v-if="!criar">
        <header>
          <h4>Resultado de Permissões</h4>
        </header>

        <div class="table-wrap">
          <div class="frame fixed micro">
            <input-control
              v-model="busca"
              placeholder="Buscar por nome ou módulo..."
              name="search"
              class="mr-auto"
              search
              preventSearchButton
            />
          </div>

          <table class="transparent-table" v-if="filteredContent.length">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Módulo</th>
                <th>Origem</th>
                <th class="text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in filteredContent" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.roleName }}</td>
                <td>{{ item.tipo }}</td>
                <td>{{ item.tipoDePermissao }}</td>
                <td class="actions">
                  <a href="#" @click.prevent="abrirEdicao(item)">
                    <fa :icon="['fal','pencil']" />
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <confirm @callback="onConfirm" ref="confirm" />
  </controller>
</template>

<script>
import axios from 'axios'
import authHeader from '@/services/auth-header'
import criarPermissoes from './Criar'

export default {
  name: "Permissões",
  components: { criarPermissoes },
  data () {
    return {
      content: [],
      criar: false,
      criarID: null,
      busca: ''
    }
  },
  mounted () {
    this.listPermissoes()
  },
  computed: {
    filteredContent() {
      if (!this.busca) return this.content
      const termo = this.busca.toLowerCase()
      return this.content.filter(item =>
        item.name?.toLowerCase().includes(termo) ||
        item.roleName?.toLowerCase().includes(termo) ||
        item.tipo?.toLowerCase().includes(termo) ||
        item.tipoDePermissao?.toLowerCase().includes(termo)
      )
    }
  },
  methods: {
    listPermissoes () {
      window.spinner.emit('open')
      axios.get(`${process.env.VUE_APP_API_URL}auth/getallpermissions`, { headers: authHeader() })
        .then(response => {
          for (let item of response.data) {
            item.tipoDePermissao = (item.angular === 0 && item.externo === 1) ? 'Metabase' : 'Router Link'
          }
          this.content = response.data
        })
        .catch(error => {
          console.error("Erro ao buscar permissões:", error)
        })
        .finally(() => {
          window.spinner.emit('close')
        })
    },
    abrirEdicao(item) {
      this.criar = true
      this.$nextTick(() => {
        this.criarID = item
      })
    },
    confirmarRemocao(item) {
      this.$refs.confirm.run({
        message: "Tem certeza que deseja remover esta permissão?",
        confirmButton: "Sim",
        denyButton: "Cancelar",
        callback: this.onConfirm,
        data: item
      })
    },
    delete(id) {
      window.spinner.emit('open')
      axios.delete(`${process.env.VUE_APP_API_URL}auth/removepermission/${id}`, { headers: authHeader() })
        .then(() => {
          window.toaster.emit('open', { style: "success", message: "Permissão removida com sucesso." })
          this.listPermissoes()
        })
        .finally(() => {
          window.spinner.emit('close')
        })
    },
    onConfirm(_, item) {
      this.delete(item.id)
    },
    close() {
      this.criar = false
      this.criarID = null
    },
    updateParentList() {
      this.listPermissoes()
    },
    novo () {
      this.criar = true
      // this.$nextTick(() => {
      //   this.$refs.form.scrollIntoView({ behavior: "smooth", block: "start" })
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.permissoes {
  padding: $hmg_mid;
  padding-bottom: $mg_large;

}

.table-wrap {
  margin-top: 1rem;
}

.table-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
}

.transparent-table {
  width: 100%;
  border-collapse: collapse;
}

.transparent-table th,
.transparent-table td {
  padding: 0.75rem;
  border-bottom: $border_component;
  text-align: left;
}

.actions {
  font-size: 18px;
  text-align: right !important;
}
</style>